export default __webpack_public_path__ + "static/media/speaker3.0a4eaf19.jpg";